import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "./style.scss";

import LogTable from "./logs-table";
import { dataToJS, pathToJS, firebaseConnect } from "react-redux-firebase";
import BlankPage from "../blank/";
import DrawerToggle from "../../containers/drawer-toggle/";
class Explore extends Component {
  constructor(props) {
    super(props);
    console.log("Explore", props);
  }

  componentWillMount() {}

  componentWillUnmount() {}

  componentWillReceiveProps(props) {
    console.log("Explore", props);
  }
  render() {
    if (this.props.group && this.props.profile.role === "admin")
      return (
        <div className="flex-container">
          <div className="toolbar">
            <DrawerToggle /><h1>{this.props.group.name} Logs</h1>
          </div>
          <div className="content log">
            <div className="page">
              <div className="max-width">

                <h1>Activate Logs</h1>
                <div className="card no-padding">
                  <LogTable
                    group={{
                      ...this.props.group,
                      _key: this.props.match.params.groupId
                    }}
                    logs={this.props.logs || []}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    return <BlankPage />;
  }
}

export default withRouter(
  connect(({ firebase }, router) => {
    return {
      group: dataToJS(firebase, `/groups/${router.match.params.groupId}`),
      logs: dataToJS(firebase, `/logs`),
      members: dataToJS(
        firebase,
        `/groups/${router.match.params.groupId}/members`
      ),
      auth: pathToJS(firebase, "auth"),
      profile: pathToJS(firebase, "profile")
    };
  })(firebaseConnect(["/groups", "/logs"])(Explore))
);



// WEBPACK FOOTER //
// ./src/routes/group-logs/index.js